import { BenchmarkParameter } from "../Models/BenchmarkParameter";
import * as ko from "knockout";
import { Variety } from "../Models/Variety";
import { UrlParameters } from "../Models/Benchmark/UrlParameters";
import { YieldCleanedMaterialReport } from "../Models/Benchmark/YieldCleanedMaterialReport";
import { YieldNormalQualityReport } from "../Models/Benchmark/YieldNormalQualityReport";
import { YieldPaymentReport } from "../Models/Benchmark/YieldPaymentReport";
import { CleaningWasteReport } from "../Models/Benchmark/CleaningWasteReport";
import { CleaningPurityReport } from "../Models/Benchmark/CleaningPurityReport";
import { CleaningGerminationReport } from "../Models/Benchmark/CleaningGerminationReport";
import { BenchmarkApi } from "../apis/BenchmarkApi";
import "footable-npm";
import * as Highcharts from 'highcharts';


export class GrowerSegmentViewModel {

    isLoading = ko.observable<boolean>(true);
    noData = ko.observable<boolean>(false);

    showNoData = ko.observable<boolean>(false);
    showFigure = ko.observable<boolean>(false);
}